const oidc = {
    logout_success: '你已经成功登出。',
};
export default oidc;
